﻿const truncateMiddle = (value, maxChars, trailingChars) => {
    if(!value || value.length <= maxChars)
        return value

    var front = value.substr(0, (maxChars - trailingChars - 3));
    var end = value.substr(-trailingChars);

    return front + "..." + end
}
export default truncateMiddle